import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FeatureFlagState, SetFeatureFlagPayload } from "../../types/featureFlags";

const initialState: FeatureFlagState = { flags: {} };

const featureFlagsSlice = createSlice({
    name: "featureFlags",
    initialState,
    reducers: {
        setFeatureFlag: (
            state,
            action: PayloadAction<SetFeatureFlagPayload>
        ) => {
            state.flags[action.payload.name] = {
                enabled: action.payload.enabled,
                ready: action.payload.ready,
            };
        },
        clearFeatureFlags: (state) => {
            state.flags = {};
        },
    },
});

export const { setFeatureFlag, clearFeatureFlags } = featureFlagsSlice.actions;

export default featureFlagsSlice.reducer;
